/**
 * TowerIcon — Mi6 canon glyph: Detroit skyline silhouette
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function TowerIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Skyline silhouette — Detroit-inspired stepped profile */}
      {/* Ground line */}
      <line x1="8" y1="66" x2="72" y2="66" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Far left low building */}
      <polyline points="8,66 8,54 14,54 14,58 18,58 18,52 24,52 24,66" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Central tall tower (Guardian / Renaissance style) */}
      <polyline points="28,66 28,36 32,36 32,24 34,24 34,18 36,18 36,14 40,10 44,14 44,18 46,18 46,24 48,24 48,36 52,36 52,66" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Antenna on top tower */}
      <line x1="40" y1="10" x2="40" y2="7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Mid-right building */}
      <polyline points="54,66 54,44 58,44 58,40 64,40 64,48 66,48 66,66" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Far right low structure */}
      <polyline points="66,66 66,56 72,56 72,66" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Window details on main tower */}
      <rect x="37" y="28" width="6" height="4" rx="0.5" stroke="currentColor" strokeWidth="1" opacity="0.6" />
      <rect x="37" y="38" width="6" height="4" rx="0.5" stroke="currentColor" strokeWidth="1" opacity="0.6" />
      <rect x="37" y="48" width="6" height="4" rx="0.5" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    </svg>
  );
}
